/**
 * Agent-Tools für VFS (Projekt-Root). Werden im AgentChat onToolCall mit projectId aufgerufen.
 */

import { vfs } from '../filesystem/VirtualFileSystem';

const ROOT = '/';

function normalizePath(p: string): string {
  const s = (p || ROOT).trim();
  return s.startsWith('/') ? s : '/' + s;
}

/**
 * Sicherheitscheck: path darf nicht aus dem Projekt-Root ausbrechen (kein "..").
 */
function resolvePath(projectId: string, relativePath: string): string | null {
  const root = vfs.getProjectRoot(projectId);
  const normalized = normalizePath(relativePath);
  const full = normalized === '/' ? root : root + normalized;
  if (!full.startsWith(root) || full.indexOf('..') !== -1) {
    return null;
  }
  return full;
}

export async function listFiles(
  projectId: string,
  path: string
): Promise<{ entries?: Array<{ name: string; isFile: boolean }>; error?: string }> {
  const fullPath = resolvePath(projectId, path || ROOT);
  if (!fullPath) {
    return { entries: [], error: 'Invalid path' };
  }
  try {
    await vfs.init();
    const entries = await vfs.readdir(fullPath);
    return {
      entries: entries.map((e) => ({ name: e.name, isFile: e.type === 'file' })),
    };
  } catch (e) {
    const msg = e instanceof Error ? e.message : String(e);
    return { entries: [], error: msg };
  }
}

export async function readFile(
  projectId: string,
  path: string
): Promise<{ content?: string; error?: string }> {
  const fullPath = resolvePath(projectId, path);
  if (!fullPath) {
    return { error: 'Invalid path' };
  }
  try {
    await vfs.init();
    const content = await vfs.readFile(fullPath);
    return { content };
  } catch (e) {
    const msg = e instanceof Error ? e.message : String(e);
    return { error: msg };
  }
}

export async function writeFile(
  projectId: string,
  path: string,
  content: string
): Promise<{ ok?: boolean; error?: string }> {
  const fullPath = resolvePath(projectId, path);
  if (!fullPath) {
    return { error: 'Invalid path' };
  }
  try {
    await vfs.init();
    await vfs.writeFile(fullPath, content);
    return { ok: true };
  } catch (e) {
    const msg = e instanceof Error ? e.message : String(e);
    return { error: msg };
  }
}
